import "./case-studies-cards.scss";

import ImageLayer from "@frontend/js/Components/Shared/ImageLayer/ImageLayer";
import DefaultImage from "@frontend/images/DefaultImage";
import { Link } from "@inertiajs/react";
import { useState } from "react";


export default function CaseStudiesCards({
    cards = [],
    limit = null,
    className = "",
    cardClassName = "caseStudiesCards__card",
    cardModifier = "",
    getHref = null,
}) {
    const [failedImages, setFailedImages] = useState({});
    const normalizedCards = cards?.data || cards || [];
    const visibleCards =
        Number.isInteger(limit) && limit > 0
            ? normalizedCards.slice(0, limit)
            : normalizedCards;

    const rootClassName = ["caseStudiesCards", className]
        .filter(Boolean)
        .join(" ");
    const linkClass = cardModifier
        ? `${cardClassName} ${cardClassName}--${cardModifier}`
        : cardClassName;

    return (
        <div className={rootClassName}>
            {visibleCards.map((card, index) => {
                const cardImage = card?.image?.url || card?.image || null;
                const cardKey = card.id || card.slug || index;
                const shouldShowImage =
                    Boolean(cardImage) && !failedImages[cardKey];
                const href =
                    typeof getHref === "function"
                        ? getHref(card, index)
                        : card?.href ||
                          route("frontend.subpage", {
                              page: "case-studies",
                              subpage: card.slug,
                          });

                return (
                    <Link key={cardKey} className={linkClass} href={href}>
                        <div className={`${cardClassName}__inner`}>
                            <ImageLayer>
                                {shouldShowImage ? (
                                    <img
                                        className={`${cardClassName}__inner__image`}
                                        src={cardImage}
                                        alt={card.title}
                                        loading="lazy"
                                        onError={() => {
                                            setFailedImages((previous) => ({
                                                ...previous,
                                                [cardKey]: true,
                                            }));
                                        }}
                                    />
                                ) : (
                                    <div
                                        className={`${cardClassName}__inner__imageFallback`}
                                        aria-hidden="true"
                                    >
                                        <DefaultImage />
                                    </div>
                                )}
                            </ImageLayer>
                            <h3 className={`${cardClassName}__title`}>
                                {card.title}
                            </h3>
                        </div>
                    </Link>
                );
            })}
        </div>
    );
}
